import { PromoConditionsConfigProps } from '../PromoConditionsAccordion.types';

export function promoConditionsConfig(props: PromoConditionsConfigProps) {
	const conditions = props.selectedData?.betSlipConditions || {};
	return {
		allIn: {
			categoryIds: conditions.outcomeAllInCategoryIds ?? [],
			eventIds: conditions.outcomeAllInEventIds ?? [],
			eventTypes: conditions.outcomeAllInEventTypes ?? [],
			gameTypes: conditions.outcomeAllInGameTypes ?? [],
		},
		oneIn: {
			categoryIds: conditions.outcomeOneInCategoryIds ?? [],
			eventTypes: conditions.outcomeOneInEventTypes ?? [],
			gameTypes: conditions.outcomeOneInGameTypes ?? [],
		},
		noneIn: {
			categoryIds: conditions.outcomeNoneInCategoryIds ?? [],
			eventIds: conditions.outcomeNoneInEventIds ?? [],
			eventTypes: conditions.outcomeNoneInEventTypes ?? [],
			gameTypes: conditions.outcomeNoneInGameTypes ?? [],
		},
		stake: {
			min: conditions.slipMinStake,
			max: conditions.slipMaxStake,
			freebetStake: props.selectedData?.freebetStake,
			offerValue: props.selectedData?.offerValue,
		},
		odds: {
			minEvent: conditions.outcomeMinOdds,
			minCoupon: conditions.combinationMinOdds,
			maxCoupon: conditions.combinationMaxOdds,
		},
		outcomes: {
			min: conditions.slipMinNumberOfOutcomes,
			max: conditions.slipMaxNumberOfOutcomes,
		},
		slipBetTypes: conditions.slipBetTypes,
	};
}
